import { Tag } from "bbcode-to-react";
import * as React from "react";
import More from "../More";
class MoreTag extends Tag {
    toHTML() {
        return [];
    }
    toReact() {
        const { id, name, wikiId } = Object.keys(this.params).reduce((prev, par) => {
            prev[par] = this.params[par].replace(/^["']|["']$/g, "");
            return prev;
        }, {});
        return (React.createElement(More, { id: id, name: name, wikiId: wikiId }, this.getContent(true)));
    }
}
export default MoreTag;
